<template>
  <a href="/cart/" class="header-carts__item header-cart header-cart--shopping" type="button">
    <i class="header-cart__icon header-cart__icon--shopping fa fa-basket-shopping"></i>
    <span class="header-cart__text">Корзина</span>
    <span
      v-if="$cart.counts && $cart.counts > 0"
      class="header-cart__label">{{ $cart.counts }}</span>
  </a>
</template>

<script>
import CartMixin from './mixins/CartMixin.vue'

export default {
  name: 'CartBlock',
  mixins: [CartMixin],
  mounted() {
    
    this.getCart()
  },
}
</script>

<style lang="scss">
</style>
